import Chip, { ChipProps } from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { CSSObject, styled } from "@mui/material/styles";

const StyledFilledChip = styled(Chip)(
  ({ theme }): CSSObject => ({
    "&.MuiChip-root": {
      borderRadius: "10px",
      backgroundColor: theme.palette.otherBackground.main,
      border: `1px solid ${theme.palette.otherOutlineBorder.main}`,
      padding: "4px 8px",
      "& .MuiChip-label": {
        padding: "0",
        color: theme.palette.text.primary,
        fontSize: "0.75rem",
        fontWeight: 500,
      },
    },
  })
);

const ChipFilledDefault = ({ ...props }: ChipProps): JSX.Element => {
  return (
    <StyledFilledChip
      label={<Typography variant="tag">{props.label}</Typography>}
      {...props}
    />
  );
};

export default ChipFilledDefault;
